import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import factWidgetIcon from "../../assets/images/fact_widget.svg";

Scrivito.provideEditingConfig("FactWidget", {
  title: "Fact",
  thumbnail: factWidgetIcon,
  attributes: localizeAttrList(["destination"], "FactWidget"),
  properties: [
    "destination",
    "icon",
    "iconPosition",
    "iconSize",
    "iconSizeTablet",
    "iconSizeMobile",
    "backgroundImage",
    "boxStyle",
  ],
  propertiesGroups: [
    {
      title: "Icon",
      component: LaIconEditorTab,
      key: "iconEditorTab",
    },
  ],
  initialContent: {
    key: "Lorem ipsum",
    value: "12",
    icon: "las la-hippo",
    iconposition: "top",
    iconSize: "300",
    boxStyle: "blue",
  },
});
